export default __webpack_public_path__ + "644c1b40fb42ecdd0abc93e0cdd6db0b.png";